import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { toSignal } from '@angular/core/rxjs-interop';
import { of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';

import { ApiSettings } from '../config/api-settings';
import { EndpointCatalogResponse } from '../models/endpoint-catalog.model';

@Injectable({ providedIn: 'root' })
export class EndpointCatalogService {
  private readonly http = inject(HttpClient);

  readonly catalog = toSignal(
    this.http.get<EndpointCatalogResponse>(`${ApiSettings.fullPath}endpoints`).pipe(
      catchError(err => {
        console.error('Failed to load the endpoint catalog.', err);
        return of(null);
      }),
      shareReplay({ bufferSize: 1, refCount: false }),
    ),
    { initialValue: null },
  );
}
